import { cartSlice } from './cart/cart.slice';

type OrderingActions = typeof cartSlice.actions;

// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
// As an added benefit, we are able to see which actions come from which slice in a central location
const {
  addCartEntry,
  addMinimalCartEntry,
  insertMinimalCartEntryAtIndex,
  replaceMinimalCartEntry,
  removeCartEntries,
  repriceCartEntries,
  resetCart,
  resetMinimalCart,
  removeMinimalCartEntry,
  setMinimalCartPricedStoreNumber,
  setMinimalCartEntries,
  setPendingMinimalCartRepriceStoreNumber,
  updateCartEntry,
  updateQuantityAndPrice,
  updateMinimalCartEntry,
  setIsPricingOrder,
  setPricedOrderId,
} = cartSlice.actions;

export const orderingActions: OrderingActions = {
  // Cart actions
  addCartEntry,
  removeCartEntries,
  repriceCartEntries,
  resetCart,
  updateCartEntry,
  updateQuantityAndPrice,
  setIsPricingOrder,
  setPricedOrderId,
  // Minimal Cart actions
  addMinimalCartEntry,
  insertMinimalCartEntryAtIndex,
  replaceMinimalCartEntry,
  removeMinimalCartEntry,
  setMinimalCartPricedStoreNumber,
  resetMinimalCart,
  setMinimalCartEntries,
  setPendingMinimalCartRepriceStoreNumber,
  updateMinimalCartEntry,
};
